import axios from './providers/axios';

const companyService = {
    getCompanies(page, filters = []) {
        let queryParams = `limit=20&page=${page}`;

        if (filters && filters.length > 0) {
            const tempFilters = filters.map((filter) => {
                return `&${filter.key}=${filter.value}`;
            }).join('');
            queryParams += tempFilters;
        }

        return axios.get(`/v1/admin/company/store?${queryParams}`);
    },

    getCompanyList() {
        return axios.get(`/v1/admin/company/store?list=1`);
    },

    addCompany(data) {
        return axios.post('/v1/admin/company/add', data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },

    getCompanyDetails(id) {
        return axios.get(`/v1/admin/company/getFromDetail/${id}`);
    },

    updateCompany(data) {
        return axios.post('/v1/admin/company/update', data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },

    deleteCompany(id) {
        return axios.delete(`/v1/admin/company/delete/${id}`);
    },

    changeInviteCode(id) {
        return axios.post(`/v1/admin/company/refreshInviteCode/${id}`);
    },

    getLogs(lang, page = 1, limit = 20) {
        return axios.get(`/v1/admin/company/getLogs?page=${page}&limit=${limit}`, {
            headers: {
                "Accept-Language": lang,
            }
        });
    },

    getDetailLogs(lang, id) {
        return axios.get(`/v1/admin/company/getLogByCompanyId?companyId=${id}`, {
            headers: {
                "Accept-Language": lang,
            }
        });
    },

    changeCompany(id) {
        return axios.get(`/v1/admin/company/change?companyId=${id}`, {})
    },

    changeCompanyList() {
        return axios.get(`/v1/admin/company/changeList?list=1`);
    },

    addCompanyLicense(data) {
        return axios.post('/v1/admin/company/package/add', data);
    },

    getCompanyLicenses(companyId) {
        return axios.post(`/v1/admin/company/package/store?companyId=${companyId}`);
    },

    getMoodStore() {
        return axios.get('/v1/admin/company/mood/store');
    },
}

export default companyService;
